<template>
  <div style="background-color: #eeeeee;">
    <van-cell :border="false">
      <div class="copyright">
        本服务由浙江政务服务网、绍兴市柯桥区漓渚镇镇政府提供
      </div>
      <div class="copyright">
        服务咨询热线：
        <span @click="Call('0575-84011058')">0575-84011058</span>
      </div>
    </van-cell>
  </div>
</template>

<script>
  import {Button, Cell, CellGroup, NavBar, Icon, Popup, Divider } from "vant";
  export default {
    name: 'MyHeader',
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Popup.name]: Popup,
      [Divider.name]: Divider,
      [Button.name]: Button
    },
    data () {
      return {
        menuShow: false
      }
    },
    props: {
    },
    watch:{
    },
    methods: {
      Call(phone) {
        if(phone) {
          ZWJSBridge.phoneCall({
            corpId: phone
          })
        }
      },
    }
  }
</script>

<style scoped>
  .van-cell{
    color: #ffffff;
    background-color: transparent;
  }
  .copyright{
    /*color: #ffffff;*/
    font-weight: bold;
    font-size: 0.8rem;
    margin: 0 auto;
    text-align: center;
  }
</style>
